import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import appleAppStoreBadge from "../../images/apple-app-store__en.svg";
import googlePlayStoreBadge from "../../images/google-play-store__en.png";
export type Store = "apple" | "google";
export function detectStore(url?: string): Store | null {
  if (typeof url !== "string") return null;
  if (url.includes("apps.apple.com")) return "apple";
  if (url.includes("play.google.com")) return "google";
  return null;
}
const badgeConfig: Record<Store, {
  src: typeof appleAppStoreBadge;
  alt: string;
}> = {
  apple: {
    src: appleAppStoreBadge,
    alt: "Download on the App Store"
  },
  google: {
    src: googlePlayStoreBadge,
    alt: "Get it on Google Play"
  }
};
export type StoreBadgeSize = "default" | "cta";
const SIZE_CLASSES: Record<StoreBadgeSize, string> = {
  default: "h-10 w-auto",
  cta: "h-[60px] w-auto"
};
export function StoreBadge(t0) {
  const $ = _c(4);
  const {
    store,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const {
    src,
    alt
  } = badgeConfig[store];
  const t2 = SIZE_CLASSES[size];
  let t3;
  if ($[0] !== alt || $[1] !== src || $[2] !== t2) {
    t3 = <Image src={src} alt={alt} className={t2} />;
    $[0] = alt;
    $[1] = src;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}